import styled from 'styled-components'

const HeroSectionStyle = styled.div`
    --phsContPaddingBottom: var(--sp15x);
    --phsBtnMarginTop: var(--sp6x);
    --phsBtnMarginBottom: var(--sp8x);
    --phsImageWidth: 69.03%;
    --phsImageProportion: 135%;
    --phsImageMarginBottom: 0;

    //!
    --rightContentMaxWidth: var(--sp121x);
	--cocktailHeroTextMTop: var(--sp3x);
	--cocktailHeroBannerMTop: var(--sp9x);
	--bannerDistance: var(--sp9x);
	--bannerLineDistance: var(--sp1-5x);
	--partWidth: 42.5%;
	--titleTextDistance: var(--sp3x);
	--ingredientsFieldDistance: var(--sp17x);
	--methodDistance: var(--sp9x);
	--methodItemDistance: var(--sp2x);
	--methodNumberSize: var(--sp3x);
	--methodTextDistance: var(--sp3x);
	--timeToolsDistance: var(--sp9x);
	--timeToolsWidth: 100%;

    padding-bottom: var(--phsContPaddingBottom);

    .phs-back-btn {
        margin-top: var(--phsBtnMarginTop);
        margin-bottom: var(--phsBtnMarginBottom);
    }

    .phs-cont {

        .phs-image-col {
            display: flex;
            justify-content: center;
            margin-bottom: var(--phsImageMarginBottom);

            .phs-image-cont {
                width: var(--phsImageWidth);

                .image-cont {
                    --proportion: var(--phsImageProportion);
                    border-radius: var(--borderRadiusSize);
                    overflow: hidden;
                }
            }
        }
        
        .phs-info-col {
            display: flex;
            flex-direction: column;
            justify-content: center;

            .phs-info-cont {
                
                width: var(--rightContentMaxWidth);

				.cocktail-hero-text {
					margin-top: var(--cocktailHeroTextMTop);
				}

				.cocktail-banner {
					margin: 0 calc(-1 * calc(var(--colPadding) / 2));
					margin-top: var(--cocktailHeroBannerMTop);
					display: flex;
					flex-wrap: wrap;

					.banner-item {
						width: var(--partWidth);
						padding: 0 calc(var(--colPadding) / 2);

						&:nth-child(n + 3) {
							margin-top: var(--bannerDistance);
						}

						.line {
							width: fit-content;
							padding-bottom: var(--bannerLineDistance);
							border-bottom: 1px solid var(--primaryColor9);
						}

						.banner-item-text {
							padding-top: var(--bannerLineDistance);
						}
					}
				}

				.cocktail-ingredients {
					margin-top: var(--subSectionDistance);

					.cocktail-ingredients-info {
						margin-top: var(--titleTextDistance);
						display: flex;

						.second-field {
							margin-left: var(--ingredientsFieldDistance);
						}

						.first-field,
						.second-field {
							.field-item {
								&:not(:first-child) {
									margin-top: calc(var(--sp1x) / 2);
								}
							}
						}
					}
				}

				.cocktail-method {
					margin-top: var(--methodDistance);

					.cocktail-method-info {
						margin-top: var(--titleTextDistance);

						.cocktail-method-info-item {
							display: flex;

							.method-number {
								width: 100%;
								border: 1px solid var(--primaryColor9);
								border-radius: 50%;
								max-width: var(--methodNumberSize);
								height: var(--methodNumberSize);
								display: flex;
								align-items: center;
								justify-content: center;
								text-align: center;
							}

							.method-text {
								margin-left: var(--methodTextDistance);
							}

							&:not(:first-child) {
								margin-top: var(--methodItemDistance);
							}
						}
					}
				}

				.cocktail-time-tools {
					margin-top: var(--timeToolsDistance);
					display: flex;
					flex-wrap: wrap;

					.cocktail-time {
						width: var(--timeToolsWidth);

						.cocktail-time-text {
							margin-top: var(--titleTextDistance);
						}
					}

					.cocktail-tools {
						width: var(--timeToolsWidth);
						margin-top: var(--timeToolsDistance);

						.cocktail-tools-text {
							margin-top: var(--titleTextDistance);
						}
					}
				}

            }
        }
    }
    @media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
        --phsContPaddingBottom: var(--sp11x);
        --phsBtnMarginTop: var(--sp4x);
        --phsBtnMarginBottom: var(--sp5x);
        --phsImageWidth: 69.91%;

        //!
        --rightContentMaxWidth: var(--sp91x);
		--cocktailHeroTextMTop: var(--sp2x);
		--cocktailHeroBannerMTop: var(--sp8x);
		--bannerDistance: var(--sp5x);
		--bannerLineDistance: var(--sp1x);
		--partWidth: 43.3%;
		--titleTextDistance: var(--sp3x);
		--ingredientsFieldDistance: var(--sp12x);
		--methodDistance: var(--sp8x);
		--methodItemDistance: var(--sp1-5x);
		--methodNumberSize: var(--sp3x);
		--methodTextDistance: var(--sp3x);
		--timeToolsDistance: var(--sp8x);
		--timeToolsWidth: 100%;
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
        --phsContPaddingBottom: var(--sp17x);
        --phsBtnMarginTop: var(--sp3x);
        --phsBtnMarginBottom: var(--sp7x);
        --phsImageWidth: 71.11%;

        //!
        --rightContentMaxWidth: var(--sp71x);
		--cocktailHeroTextMTop: var(--sp3x);
		--cocktailHeroBannerMTop: var(--sp7x);
		--bannerDistance: var(--sp5x);
		--bannerLineDistance: var(--sp1x);
		--partWidth: 50%;
		--titleTextDistance: var(--sp3x);
		--ingredientsFieldDistance: var(--sp9x);
		--methodDistance: var(--sp7x);
		--methodItemDistance: var(--sp1-5x);
		--methodNumberSize: var(--sp3x);
		--methodTextDistance: var(--sp3x);
		--timeToolsDistance: var(--sp7x);
		--timeToolsWidth: 100%;
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
        --phsContPaddingBottom: var(--sp9x);
        --phsBtnMarginTop: var(--sp2x);
        --phsBtnMarginBottom: var(--sp4x);
        --phsImageWidth: 70.03%;

        //!
        --rightContentMaxWidth: var(--sp70x);
		--cocktailHeroTextMTop: var(--sp2x);
		--cocktailHeroBannerMTop: var(--sp6x);
		--bannerDistance: var(--sp5x);
		--bannerLineDistance: var(--sp1x);
		--partWidth: 50%;
		--titleTextDistance: var(--sp3x);
		--ingredientsFieldDistance: var(--sp8x);
		--methodDistance: var(--sp6x);
		--methodItemDistance: var(--sp1-5x);
		--methodNumberSize: var(--sp3x);
		--methodTextDistance: var(--sp3x);
		--timeToolsDistance: var(--sp6x);
		--timeToolsWidth: 100%;
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
        --phsContPaddingBottom: var(--sp7x);
        --phsBtnMarginTop: var(--sp2x);
        --phsBtnMarginBottom: var(--sp4x);
        --phsImageWidth: 82.43%;

        //!
        --rightContentMaxWidth: var(--sp66x);
		--cocktailHeroTextMTop: var(--sp3x);
		--cocktailHeroBannerMTop: var(--sp5x);
		--bannerDistance: var(--sp5x);
		--bannerLineDistance: var(--sp1x);
		--partWidth: 50%;
		--titleTextDistance: var(--sp3x);
		--ingredientsFieldDistance: var(--sp8x);
		--methodDistance: var(--sp5x);
		--methodItemDistance: var(--sp1-5x);
		--methodNumberSize: var(--sp3x);
		--methodTextDistance: var(--sp3x);
		--timeToolsDistance: var(--sp5x);
		--timeToolsWidth: 100%;
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
        --phsContPaddingBottom: var(--sp9x);
        --phsBtnMarginTop: var(--sp3x);
        --phsBtnMarginBottom: var(--sp6x);
        --phsImageWidth: 65.53%;

        //!
        --rightContentMaxWidth: var(--sp60x);
		--cocktailHeroTextMTop: var(--sp2x);
		--cocktailHeroBannerMTop: var(--sp4x);
		--bannerDistance: var(--sp5x);
		--bannerLineDistance: var(--sp1x);
		--partWidth: 50%;
		--titleTextDistance: var(--sp2x);
		--ingredientsFieldDistance: var(--sp4x);
		--methodDistance: var(--sp5x);
		--methodItemDistance: var(--sp1-5x);
		--methodNumberSize: var(--sp3x);
		--methodTextDistance: var(--sp3x);
		--timeToolsDistance: var(--sp5x);
		--timeToolsWidth: 100%;

        .cocktail-hero-info {
			padding-left: 0 !important;
		}

		.cocktail-banner {
			width: 100% !important;
		}

		.first-field {
			max-width: var(--sp20x) !important;
			width: 100% !important;
		}
	}

    @media only screen and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
        .phs-cont {
            .phs-image-col {
                justify-content: center;
            }
        }
    }

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
        --phsContPaddingBottom: var(--sp8x);
        --phsBtnMarginTop: var(--sp2x);
        --phsBtnMarginBottom: var(--sp3x);
        --phsImageWidth: 65.53%;
        --phsImageMarginBottom: var(--sp3x);

        //!
        --rightContentMaxWidth: 100%;
		--cocktailHeroTextMTop: var(--sp2x);
		--cocktailHeroBannerMTop: var(--sp7x);
		--bannerDistance: var(--sp5x);
		--bannerLineDistance: var(--sp1x);
		--partWidth: 50%;
		--titleTextDistance: var(--sp2x);
		--ingredientsFieldDistance: var(--sp3x);
		--methodDistance: var(--sp5x);
		--methodItemDistance: var(--sp1-5x);
		--methodNumberSize: var(--sp3x);
		--methodTextDistance: var(--sp3x);
		--timeToolsDistance: var(--sp5x);
		--timeToolsWidth: 50%;

        .cocktail-hero-info {
			margin-top: var(--sp7x);
		}

		.cocktail-banner {
			width: 100% !important;
		}

		.first-field {
			max-width: var(--sp19x) !important;
			width: 100% !important;
		}

		.cocktail-time-tools {
			margin: 0 calc(-1 * calc(var(--colPadding) / 2));

			.cocktail-tools {
				margin-top: 0 !important;
			}

			.cocktail-time,
			.cocktail-tools {
				padding: 0 calc(var(--colPadding) / 2);
			}
		}
	}

	@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
        --phsContPaddingBottom: var(--sp8x);
        --phsBtnMarginTop: var(--sp3x);
        --phsBtnMarginBottom: var(--sp2x);
        --phsImageWidth: 100%;
        --phsImageMarginBottom: var(--sp4x);

        //!
        --rightContentMaxWidth: 100%;
		--cocktailHeroTextMTop: var(--sp2x);
		--cocktailHeroBannerMTop: var(--sp4x);
		--bannerDistance: var(--sp4x);
		--bannerLineDistance: var(--sp1x);
		--partWidth: 50%;
		--titleTextDistance: var(--sp2x);
		--ingredientsFieldDistance: unset;
		--methodDistance: var(--sp5x);
		--methodItemDistance: var(--sp1-5x);
		--methodNumberSize: var(--sp3x);
		--methodTextDistance: var(--sp1-5x);
		--timeToolsDistance: var(--sp5x);
		--timeToolsWidth: 100%;

        .cocktail-hero-info {
			margin-top: var(--sp4x);
		}

		.cocktail-ingredients-info {
			justify-content: space-between;
			margin: 0 calc(-1 * calc(var(--colPadding) / 2)) !important;
			margin-top: var(--titleTextDistance) !important;

			.first-field,
			.second-field {
				padding: 0 calc(var(--colPadding) / 2) !important;
			}
		}
	}
`

export default HeroSectionStyle